export default "__VITE_ASSET__CDUfowxH__"